import { MapOptions } from "mapbox-gl";

import type { MapBounds } from "./components/MapButtonFitBounds/types";

const VITE_MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

export const DEFAULT_MAPBOX_CONFIG: Partial<MapOptions> = {
    accessToken: VITE_MAPBOX_ACCESS_TOKEN,
    logoPosition: "bottom-right",
};

export const MAP_MARGIN = 32;
const MAP_PANEL_MARGIN_TOTAL = MAP_MARGIN * 2;

export const MAP_PANEL_WIDTH_LEGEND = 240;
export const MAP_PANEL_WIDTH_THIN = 400;
export const MAP_PANEL_WIDTH_WIDE = 600;
export const MAP_BAR_HEIGHT = 40;

export const MAP_PADDING_PANEL_HORIZONTAL = MAP_PANEL_WIDTH_THIN + MAP_PANEL_MARGIN_TOTAL;
export const MAP_PADDING_BAR_VERTICAL = MAP_BAR_HEIGHT + MAP_PANEL_MARGIN_TOTAL;

export const MAP_PADDING = {
    top: MAP_PADDING_BAR_VERTICAL,
    bottom: MAP_PADDING_BAR_VERTICAL,
    left: MAP_PADDING_PANEL_HORIZONTAL,
    right: 0,
};

export const NETHERLANDS_BBOX = [3.3585, 50.7504, 7.2275, 53.5506] as GeoJSON.BBox;

export const NETHERLANDS_BOUNDS: MapBounds = { bbox: NETHERLANDS_BBOX, kind: "netherlands" };

export const MAP_CENTER_ADDRESS_RADIUS_KM = 0.025;

// https://docs.mapbox.com/mapbox-gl-js/api/properties/#animationoptions
export const MAP_ANIMATE_OPTIONS = {
    speed: 2.4, // twice the mapbox default of 1.2
};
